<template>
  <div class="flex flex-col">
    <transition name="fade">
      <div
        v-if="$store.state.step_one.advertisingGoal"
        class="flex py-6 pb-16 mx-[10%] items-center justify-items-center w-[75%]">
        <div
          class="flex flex-col flex-wrap items-center animate__animated animate__backInLeft"
          :class="[$store.state.freeStep == 1 ? 'font-bold' : '']"
        >
          <svg
            v-if="$store.state.freeStep == 1"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g
              id="Group_16637"
              data-name="Group 16637"
              transform="translate(-116 -177.467)"
            >
              <circle
                id="Ellipse_1229"
                data-name="Ellipse 1229"
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(116 177.467)"
                fill="#369da3"
              />
            </g>
          </svg>
          <svg
            v-if="$store.state.freeStep > '1'"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g id="check" transform="translate(-116 -177.467)">
              <circle
                id="Ellipse_1229"
                data-name="Ellipse 1229"
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(116 177.467)"
                fill="#369da3"
              />
              <g
                id="svgexport-6_-_2022-08-15T172228.143"
                data-name="svgexport-6 - 2022-08-15T172228.143"
                transform="translate(123.207 186.159)"
              >
                <g
                  id="Group_2656"
                  data-name="Group 2656"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_2655"
                    data-name="Group 2655"
                    transform="translate(0 0)"
                  >
                    <path
                      id="Path_25615"
                      data-name="Path 25615"
                      d="M10.339,72.034a.84.84,0,0,0-1.187,0L3.808,77.378,1.433,75A.84.84,0,0,0,.245,76.19l2.969,2.969a.839.839,0,0,0,1.187,0l5.937-5.937A.84.84,0,0,0,10.339,72.034Z"
                      transform="translate(0.001 -71.788)"
                      fill="#f9f9f9"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>

          <p class="text-center text-[18px] w-max absolute mt-8">
            Campaign Info
          </p>
        </div>
        <div class="mx-auto animate__animated animate__backInLeft"><img src="../../assets/Line.svg" /></div>
        <div
          v-if="$store.state.step_one.advertisingGoal == 'Conversions'"
          class="flex flex-col items-center gap-2 animate__animated animate__backInLeft"
          :class="[$store.state.freeStep == 2 ? 'font-bold' : '']"
        >
          <svg
            v-if="$store.state.freeStep == 2"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g
              id="Group_16637"
              data-name="Group 16637"
              transform="translate(-116 -177.467)"
            >
              <circle
                id="Ellipse_1229"
                data-name="Ellipse 1229"
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(116 177.467)"
                fill="#369da3"
              />
            </g>
          </svg>

          <svg
            v-if="$store.state.freeStep < 2"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g
              id="Ellipse_1253"
              data-name="Ellipse 1253"
              fill="none"
              stroke="#000"
              stroke-width="1"
            >
              <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
              <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
          </svg>

          <svg
            v-if="$store.state.freeStep > 2"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g id="check" transform="translate(-116 -177.467)">
              <circle
                id="Ellipse_1229"
                data-name="Ellipse 1229"
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(116 177.467)"
                fill="#369da3"
              />
              <g
                id="svgexport-6_-_2022-08-15T172228.143"
                data-name="svgexport-6 - 2022-08-15T172228.143"
                transform="translate(123.207 186.159)"
              >
                <g
                  id="Group_2656"
                  data-name="Group 2656"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_2655"
                    data-name="Group 2655"
                    transform="translate(0 0)"
                  >
                    <path
                      id="Path_25615"
                      data-name="Path 25615"
                      d="M10.339,72.034a.84.84,0,0,0-1.187,0L3.808,77.378,1.433,75A.84.84,0,0,0,.245,76.19l2.969,2.969a.839.839,0,0,0,1.187,0l5.937-5.937A.84.84,0,0,0,10.339,72.034Z"
                      transform="translate(0.001 -71.788)"
                      fill="#f9f9f9"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>

          <p class="text-center text-[18px] absolute mt-8">Targeting</p>
        </div>
        <div
          v-if="$store.state.step_one.advertisingGoal == 'Conversions'"
          class="mx-auto animate__animated animate__backInLeft"
        >
          <img src="../../assets/Line.svg" />
        </div>
        <div
          class="flex flex-col items-center gap-2 animate__animated animate__backInLeft"
          :class="[$store.state.freeStep == 3 ? 'font-bold' : '']"
        >
          <svg
            v-if="$store.state.freeStep == 3"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g
              id="Group_16637"
              data-name="Group 16637"
              transform="translate(-116 -177.467)"
            >
              <circle
                id="Ellipse_1229"
                data-name="Ellipse 1229"
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(116 177.467)"
                fill="#369da3"
              />
            </g>
          </svg>

          <svg
            v-if="$store.state.freeStep < 3"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g
              id="Ellipse_1253"
              data-name="Ellipse 1253"
              fill="none"
              stroke="#000"
              stroke-width="1"
            >
              <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
              <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
          </svg>

          <svg
            v-if="$store.state.freeStep > 3"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g id="check" transform="translate(-116 -177.467)">
              <circle
                id="Ellipse_1229"
                data-name="Ellipse 1229"
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(116 177.467)"
                fill="#369da3"
              />
              <g
                id="svgexport-6_-_2022-08-15T172228.143"
                data-name="svgexport-6 - 2022-08-15T172228.143"
                transform="translate(123.207 186.159)"
              >
                <g
                  id="Group_2656"
                  data-name="Group 2656"
                  transform="translate(0 0)"
                >
                  <g
                    id="Group_2655"
                    data-name="Group 2655"
                    transform="translate(0 0)"
                  >
                    <path
                      id="Path_25615"
                      data-name="Path 25615"
                      d="M10.339,72.034a.84.84,0,0,0-1.187,0L3.808,77.378,1.433,75A.84.84,0,0,0,.245,76.19l2.969,2.969a.839.839,0,0,0,1.187,0l5.937-5.937A.84.84,0,0,0,10.339,72.034Z"
                      transform="translate(0.001 -71.788)"
                      fill="#f9f9f9"
                    />
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <p class="text-center text-[18px] absolute mt-8">Budget</p>
        </div>
        <div class="mx-auto animate__animated animate__backInLeft"><img src="../../assets/Line.svg" /></div>
        <div
          class="flex flex-col items-center gap-2 animate__animated animate__backInLeft"
          :class="[$store.state.freeStep == 4 ? 'font-bold' : '']"
        >
          <svg
            v-if="$store.state.freeStep == 4"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g
              id="Group_16637"
              data-name="Group 16637"
              transform="translate(-116 -177.467)"
            >
              <circle
                id="Ellipse_1229"
                data-name="Ellipse 1229"
                cx="12.5"
                cy="12.5"
                r="12.5"
                transform="translate(116 177.467)"
                fill="#369da3"
              />
            </g>
          </svg>

          <svg
            v-if="$store.state.freeStep < 4"
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="25"
            viewBox="0 0 25 25"
          >
            <g
              id="Ellipse_1253"
              data-name="Ellipse 1253"
              fill="none"
              stroke="#000"
              stroke-width="1"
            >
              <circle cx="12.5" cy="12.5" r="12.5" stroke="none" />
              <circle cx="12.5" cy="12.5" r="12" fill="none" />
            </g>
          </svg>

          <p class="text-center text-[18px] absolute mt-8">Media</p>
        </div>
      </div>
    </transition>
      <div class="flex flex-col justify-center">
        <step-one v-if="$store.state.freeStep === 1"></step-one>
        <step-two v-if="$store.state.freeStep === 2"></step-two>
        <step-three v-if="$store.state.freeStep === 3"></step-three>
        <step-four v-if="$store.state.freeStep === 4"></step-four>
      </div>
  </div>
</template>

<script>
import StepFour from "../../components/FreeCampaignTaps/StepFour.vue";
import StepOne from "../../components/FreeCampaignTaps/StepOne.vue";
import StepThree from "../../components/FreeCampaignTaps/StepThree.vue";
import StepTwo from "../../components/FreeCampaignTaps/StepTwo.vue";
import 'animate.css';

export default {
  components: { StepTwo, StepOne, StepThree, StepFour },
};
</script>

<style>
.progress-bar {
  transition: opacity 0.5s;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
